import { render, staticRenderFns } from "./WebTradeView.vue?vue&type=template&id=56fc26a4"
import script from "./WebTradeView.vue?vue&type=script&lang=js"
export * from "./WebTradeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports